import ApiCoreService from "./api.core.service";

export default class LoginService extends ApiCoreService {
    static async sendOtp(phoneNumber, caNumber, uType) {
        console.log(phoneNumber, caNumber, uType);
        try {
            return await this.graphCall('sendOtpForAggregator', `{
                sendOtpForAggregator(email: "${phoneNumber}@p2penergy.ai", phone: "${phoneNumber}", aggregatorCode: "tpddl_vb", uType: ${uType}, caNumber: "${caNumber}")
                {
                    success
                    ctx
                }
            }`);
        } catch (c) {
            throw new Error(c);
        }
    }

    static async sendAggOtp(phoneNumber, email, aggregatorCode) {
        try {
            return await this.graphCall('sendOtpForAggregator', `{
                sendOtpForAggregator(email: "${email}" phone: "${phoneNumber}" aggregatorCode: "${aggregatorCode}") {
                    success
                    ctx
                }
            }`);
        } catch (c) {
            throw new Error(c);
        }
    }

    static async verifyOtp(otp, ctx) {
        try {
            return await this.graphCall(
                "verifyP2POtp",
                `{
                verifyP2POtp(otp: "${otp}", ctx: "${ctx}") {
                    success
                    token
                    id
                }
            }`,
                {}
            );
        } catch (c) {
            throw new Error(c);
        }
    }

    static get token() {
        const token = localStorage.getItem('_token'); // Fetch from localStorage
        return token ? token : null;
    }

   

   
}
